<template>
  <div>
    <v-flex text-18-security blue-security font-weight-bold pb-2>MOMENTOS</v-flex>
    <v-flex v-for="post in relatedPosts" :key="post.id" @click="goToShowPost(post)" pb-4>
      <v-card flat hover width="390" max-height="160">
        <v-layout row wrap>
          <v-flex sm5>
            <v-img :src="post.main_image" height="160" width="160"></v-img>
          </v-flex>
          <v-flex sm7 pt-2 pl-3>
            <v-flex text-14-security grey-security>{{ post.published_at }}</v-flex>
            <v-flex pt-1 text-18-security blue-security font-weight-bold>{{ post.title }}</v-flex>
            <v-flex pt-2 grey-security>{{ post.extract }}</v-flex>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import axios from "axios";

export default {
  props: {
    relatedPosts: {
      type: Array,
      required: false
    }
  },
  methods: {
    ...mapMutations("posts", ["setPost"]),
    async goToShowPost(post) {
      if (post.post_type == "Video") {  
        this.$router.push({
          name: "post-moment-show",
          params: { slug: post.slug }
        });
      } else {
        this.$router.push({
          name: "post-show",
          params: { slug: post.slug }
        });
      }

      const res = await axios.get(process.env.VUE_APP_API_URL + `/posts_video/post?slug=${post.slug}`)
      this.setPost(res.data);
    }
  }
};
</script>

<style>
</style>